import React, { createContext, useContext, useRef, ReactNode } from 'react';
import { ChatBot, ChatBotRef } from '../components/chat/ChatBot';
import { executeAgentAction } from '../services/aiService';

interface ChatBotContextType {
  openChat: () => void;
  executeAction: (action: any) => Promise<void>;
}

const ChatBotContext = createContext<ChatBotContextType | undefined>(undefined);

export const useChatBot = () => {
  const context = useContext(ChatBotContext);
  if (!context) {
    throw new Error('useChatBot must be used within a ChatBotProvider');
  }
  return context;
};

interface ChatBotProviderProps {
  children: ReactNode;
}

export const ChatBotProvider: React.FC<ChatBotProviderProps> = ({ children }) => {
  const chatBotRef = useRef<ChatBotRef>(null);

  const openChat = () => {
    chatBotRef.current?.open();
  };

  const executeAction = async (action: any) => {
    // Implémentation de executeAction
  };

  return (
    <ChatBotContext.Provider value={{ openChat, executeAction }}>
      {children}
      <ChatBot ref={chatBotRef} />
    </ChatBotContext.Provider>
  );
}; 